export const getError = state => state.addSystem.get('error')
export const getIsSubmitting = state => state.addSystem.get('isSubmitting')
